'use strict';

const _ = require('underscore');
const GroupPermission = require('common/domain/entity/group-permission');

class Factory {
    build(json) {
        const type = json.type;
        const klass = _.find(GroupPermission.GroupPermissions, klass => {
            return klass.type == type;
        });

        if(klass) {
            return new klass(json.data);
        }
    }
}

module.exports = Factory;


// WEBPACK FOOTER //
// ./common/domain/factory/group-permission.js